import * as actionTypes from './../../actionTypes/returnExchange';

const initialState = {
  headerTitle: null,
  hideNav: false,
  loading: false,
  userAddress: '',
  // return
  orderReturnableStatus: null,
  returnProducts: [],
  nearbyStore: [],
  returnModes: {},
  returnDetails: null,
  isAddressServiceable: null,
  returnLabelGenerated: null,
  // exchange
  isExchange: false,
  paymentData: null,
  paymentMethods: null,
  // post return
  itemReturnDetails: null,
  returnActionsDetail: null,
  exchangeOrderId: null,
  exchangeItemId: null,
  // refund
  refundDetails: null,
  refundEstimateData: null
};

export default function returnExchange(prevState = initialState, action) {
  let xApiClient = 'desktop';
  // conditional imports on compilation
  '#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
  xApiClient = 'mobilesite';
  '#endif'; // eslint-disable-line
  switch (action.type) {
    case actionTypes.HEADER_UPDATE:
      return Object.assign({}, prevState, {
        headerTitle: action.title
      });
    case actionTypes.HIDE_NAV:
      return Object.assign({}, prevState, {
        hideNav: action.flag !== false
      });
    case actionTypes.SET_RETURN_PRODUCTS:
      return Object.assign({}, prevState, {
        returnProducts: action.products
      });
    case actionTypes.MERGE_RETURN_DETAILS:
      return Object.assign({}, prevState, {
        returnDetails: action.data
      });
    case actionTypes.STORE_LOCATION_LOAD:
      return Object.assign({}, prevState, {
        loadingNearByStore: true
      });
    case actionTypes.STORE_LOCATION_SUCCESS:
      return Object.assign({}, prevState, {
        nearbyStore: action.data,
        loadingNearByStore: false
      });
    case actionTypes.STORE_LOCATION_FAIL:
      return Object.assign({}, prevState, {
        nearbyStore: action.error,
        loadingNearByStore: false
      });
    case actionTypes.USER_ADDRESS_UPDATE:
      return Object.assign({}, prevState, {
        userAddress: action.address
      });
    case actionTypes.STORE_ADDRESS_UPDATE:
      return Object.assign({}, prevState, {
        storeAddress: action.address
      });
    case actionTypes.CREATE_RETURN_LOAD:
      return Object.assign({}, prevState, {
        loading: true
      });
    case actionTypes.CREATE_RETURN_SUCCESS:
      return Object.assign({}, prevState, {
        returnDetails: action.data,
        loading: false
      });
    case actionTypes.CREATE_RETURN_FAIL:
      return Object.assign({}, prevState, {
        returnDetails: action.error,
        loading: false
      });
    case actionTypes.GET_RETURN_REASONS:
      return Object.assign({}, prevState, {
        loading: true
      });
    case actionTypes.GET_RETURN_REASONS_SUCCESS:
      return Object.assign({}, prevState, {
        returnReasons: action.data,
        loading: false
      });
    case actionTypes.GET_RETURN_REASONS_FAIL:
      return Object.assign({}, prevState, {
        returnReasonsErr: action.error,
        loading: false
      });
    case actionTypes.GET_RETURN_MODES_LOAD:
      return Object.assign({}, prevState, {
        returnModes: {},
        loading: true
      });
    case actionTypes.GET_RETURN_MODES_SUCCESS:
      return Object.assign({}, prevState, {
        returnModes: action.data.result,
        loading: false
      });
    case actionTypes.GET_RETURN_MODES_FAIL:
      return Object.assign({}, prevState, {
        returnModes: action.error,
        loading: false
      });
    case actionTypes.GET_SERVICEABLE_ADDRESS_LOAD:
      return Object.assign({}, prevState, {
        isAddressServiceable: null,
        loading: true
      });
    case actionTypes.GET_SERVICEABLE_ADDRESS_SUCCESS:
      return Object.assign({}, prevState, {
        isAddressServiceable: action.data.result.serviceable,
        loading: false
      });
    case actionTypes.GET_SERVICEABLE_ADDRESS_FAIL:
      return Object.assign({}, prevState, {
        isAddressServiceable: false,
        loading: false
      });
    case actionTypes.GET_RETURN_DETAILS_LOAD:
      return Object.assign({}, prevState, {
        itemReturnDetails: null,
        loading: true
      });
    case actionTypes.GET_RETURN_DETAILS_SUCCESS:
      return Object.assign({}, prevState, {
        itemReturnDetails: action.data,
        loading: false
      });
    case actionTypes.GET_RETURN_DETAILS_FAIL:
      return Object.assign({}, prevState, {
        itemReturnDetails: action.error,
        loading: false
      });
    case actionTypes.GET_RETURN_ACTIONS_LOAD:
      return Object.assign({}, prevState, {
        loading: true
      });
    case actionTypes.GET_RETURN_ACTIONS_SUCCESS:
      return Object.assign({}, prevState, {
        returnActionsDetail: action.data,
        loading: false
      });
    case actionTypes.GET_RETURN_ACTIONS_FAIL:
      return Object.assign({}, prevState, {
        returnActionsDetail: action.error,
        loading: false
      });
    case actionTypes.GET_PAYMENT_DATA_LOAD:
      return Object.assign({}, prevState, {
        loading: true
      });
    case actionTypes.GET_PAYMENT_DATA_SUCCESS:
      return Object.assign({}, prevState, {
        paymentData: action.data.paymentData,
        loading: false
      });
    case actionTypes.GET_PAYMENT_DATA_FAIL:
      return Object.assign({}, prevState, {
        paymentData: action.error,
        loading: false
      });
    case actionTypes.GET_PAYMENT_METHODS_LOAD:
      return Object.assign({}, prevState, {
        loading: true
      });
    case actionTypes.GET_PAYMENT_METHODS_SUCCESS:
      return Object.assign({}, prevState, {
        paymentMethods: action.data,
        loading: false
      });
    case actionTypes.GET_PAYMENT_METHODS_FAIL:
      return Object.assign({}, prevState, {
        paymentMethods: action.error,
        loading: false
      });
    case actionTypes.CREATE_REFUND_LOAD:
      return Object.assign({}, prevState, {
        loading: true
      });
    case actionTypes.CREATE_REFUND_SUCCESS:
      return Object.assign({}, prevState, {
        refundDetails: action.data,
        loading: false
      });
    case actionTypes.CREATE_REFUND_FAIL:
      return Object.assign({}, prevState, {
        refundDetails: action.error,
        loading: false
      });
    case actionTypes.SET_IS_EXCHANGE:
      return Object.assign({}, prevState, {
        isExchange: xApiClient === 'mobilesite' && action.flag || false
      });
    case actionTypes.SET_EXCHANGE_ORDER_AND_ITEM:
      return Object.assign({}, prevState, {
        exchangeOrderId: action.orderId,
        exchangeItemId: action.itemId
      });
    case actionTypes.SET_EXCHANGE_RETURN_CLEAN:
      return Object.assign({}, initialState);
    case actionTypes.GET_REFUND_ESTIMATE_LOAD:
      return Object.assign({}, prevState, {
        loading: true
      });
    case actionTypes.GET_REFUND_ESTIMATE_SUCCESS:
      return Object.assign({}, prevState, {
        refundEstimateData: action.data,
        loading: false
      });
    case actionTypes.GET_REFUND_ESTIMATE_FAIL:
      return Object.assign({}, prevState, {
        refundEstimateData: action.error,
        loading: false
      });
    case actionTypes.GET_ELIGIBILITY_RETURN_STATUS:
      return Object.assign({}, prevState, { loading: true, orderReturnableStatus: null });
    case actionTypes.GET_ELIGIBILITY_RETURN_STATUS_SUCCESS:
      return Object.assign({}, prevState, { loading: false, orderReturnableStatus: action.data });
    case actionTypes.GET_ELIGIBILITY_RETURN_STATUS_FAIL:
      return Object.assign({}, prevState, { loading: false, orderReturnableStatus: action.error });
    case actionTypes.GET_RETURN_LABEL_STATUS_LOAD:
      return Object.assign({}, prevState, {
        returnLabelGenerated: null
      });
    case actionTypes.GET_RETURN_LABEL_STATUS_SUCCESS:
      return Object.assign({}, prevState, {
        returnLabelGenerated: action.data && action.data.success
      });
    case actionTypes.GET_RETURN_LABEL_STATUS_FAIL:
      return Object.assign({}, prevState, {
        returnLabelGenerated: false
      });
    default: return prevState;
  }
}
